// extracted by mini-css-extract-plugin
export default {"point_area":"Point_point_area__BlAsn","contents":"Point_contents__nLOUD","card":"Point_card__QZsxv","title":"Point_title__n7kO6"};